import caseIcon from '../../assets/images/brands/case.svg';
import claasIcon from '../../assets/images/brands/claas.svg';
import daedongIcon from '../../assets/images/brands/daedong.svg';
import defaultIcon from '../../assets/images/brands/default.svg';
import deutzFahrIcon from '../../assets/images/brands/deutz_fahr.svg';
import fendtIcon from '../../assets/images/brands/fendt.svg';
import isekiIcon from '../../assets/images/brands/iseki.svg';
import johnDeereIcon from '../../assets/images/brands/john_deere.svg';
import kubotaIcon from '../../assets/images/brands/kubota.svg';
import lsIcon from '../../assets/images/brands/ls.svg';
import masseyFergusonIcon from '../../assets/images/brands/massey_ferguson.svg';
import newHollandIcon from '../../assets/images/brands/new_holland.svg';
import tymIcon from '../../assets/images/brands/tym.svg';
import valtraIcon from '../../assets/images/brands/valtra.svg';
import yanmarIcon from '../../assets/images/brands/yanmar.svg';

export const BRAND_ICON_MAP: Record<string, string> = {
  존디어: johnDeereIcon,
  뉴홀랜드: newHollandIcon,
  구보다: kubotaIcon,
  얀마: yanmarIcon,
  대동: daedongIcon,
  'TYM(국제)': tymIcon,
  LS: lsIcon,
  'TYM(동양)': tymIcon,
  도이치파: deutzFahrIcon,
  '메시퍼거슨(아세아텍)': masseyFergusonIcon,
  발트라: valtraIcon,
  이세키: isekiIcon,
  케이스: caseIcon,
  펜트: fendtIcon,
  '클라스(아세아텍)': claasIcon,
} as const;

export const getBrandIconUrl = (brandName: string): string => {
  if (BRAND_ICON_MAP[brandName]) {
    return BRAND_ICON_MAP[brandName];
  }

  return defaultIcon;
};
